import React, { useMemo, useState } from 'react';

import { Theme, makeStyles } from '@material-ui/core/styles';
import Link from '@material-ui/core/Link';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import useTheme from '@material-ui/core/styles/useTheme';
import Slide from '@material-ui/core/Slide';
import moment from 'moment';
import { LOCAL_STORAGE_SNS_DISPLAY_KEY } from '../../../constants/localStorage';
import {
  SNS_BANNER_EXPIRING_DURATION,
  SNS_BANNER_INCREMENT_Z_INDEX,
  LINE_BANNER_ID,
  INSTAGRAM_BANNER_ID,
  CLOSE_SNS_BANNER_ID,
} from '../constants';
import { PLANS, HOME } from '../../../constants/routing';
import PcSnsClose from '../../../images/header/sns_banners/pc_sns_close.png';
import SpSnsClose from '../../../images/header/sns_banners/sp_sns_close.png';
import PcSnsInsta from '../../../images/header/sns_banners/pc_sns_insta.png';
import PcSnsLine from '../../../images/header/sns_banners/pc_sns_line.png';
import PcSnsTab from '../../../images/header/sns_banners/pc_sns_tab.png';
import SpSnsInsta from '../../../images/header/sns_banners/sp_sns_insta.png';
import SpSnsLine from '../../../images/header/sns_banners/sp_sns_line.png';
import SpSnsTab from '../../../images/header/sns_banners/sp_sns_tab.png';

const useStyles = makeStyles((theme: Theme) => ({
  snsBnr: {
    position: 'fixed',
    bottom: '10%',
    right: 0,
    backgroundImage: `url(${SpSnsTab})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    zIndex: theme.zIndex.appBar + SNS_BANNER_INCREMENT_Z_INDEX,
    width: '90px',
    height: '200px',
    [theme.breakpoints.up('sm')]: {
      bottom: '5%',
      top: 'auto',
      backgroundImage: `url(${PcSnsTab})`,
      width: '130px',
      height: '280px',
    },
  },
  closeBtn: {
    width: '100%',
    cursor: 'pointer',
    verticalAlign: 'top',
    pointerEvents: 'none',
  },
  snsLine: {
    width: '70px',
    position: 'absolute',
    right: '0',
    top: '25%',
    cursor: 'pointer',
    [theme.breakpoints.up('sm')]: {
      width: '110px',
      top: '20%',
    },
  },
  snsInsta: {
    position: 'absolute',
    width: '70px',
    right: '0',
    top: '60%',
    cursor: 'pointer',
    [theme.breakpoints.up('sm')]: {
      width: '110px',
      top: '58%',
    },
  },
  snsLink: {
    display: 'block',
  },
  snsImg: {
    width: '100%',
    pointerEvents: 'none',
  },
}));

const SnsBanner = () => {
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('sm'));
  const [checked, setChecked] = useState(false);
  const setLocalStorage = () =>
    localStorage.setItem(LOCAL_STORAGE_SNS_DISPLAY_KEY, moment().toISOString());
  const handleClose = () => {
    setChecked(true);
    setLocalStorage();
  };

  const defaultHideBanner = useMemo(() => {
    const lastDisplayDate = localStorage.getItem(LOCAL_STORAGE_SNS_DISPLAY_KEY);
    if (!lastDisplayDate && !moment(lastDisplayDate).isValid()) return;

    const diff = moment().diff(moment(lastDisplayDate), 'hours');
    return diff < SNS_BANNER_EXPIRING_DURATION;
  }, []);

  if (defaultHideBanner) return null;

  const currentPath = window.location.pathname;
  const lineUrl = () => {
    switch (currentPath) {
      case HOME:
        return process.env.LINE_HOME_OFFICIAL_DIRECT_URL;
      case PLANS:
        return process.env.LINE_PLAN_OFFICIAL_DIRECT_URL;
      default:
        return process.env.OFFICIAL_LINE_DIRECT_URL;
    }
  };

  return (
    <Slide direction="left" in={!checked} mountOnEnter>
      <div className={classes.snsBnr}>
        <div onClick={handleClose} id={CLOSE_SNS_BANNER_ID}>
          <img
            src={matches ? PcSnsClose : SpSnsClose}
            className={classes.closeBtn}
            alt="CLOSE"
          />
        </div>
        <div className={classes.snsLine}>
          <Link
            href={lineUrl()}
            id={LINE_BANNER_ID}
            className={classes.snsLink}
            target="_blank"
            rel="noopener"
          >
            <img
              src={matches ? PcSnsLine : SpSnsLine}
              className={classes.snsImg}
              alt="LINE"
            />
          </Link>
        </div>
        <div className={classes.snsInsta}>
          <Link
            href={process.env.OFFICIAL_INSTAGRAM_URL}
            id={INSTAGRAM_BANNER_ID}
            className={classes.snsLink}
            target="_blank"
            rel="noopener"
          >
            <img
              src={matches ? PcSnsInsta : SpSnsInsta}
              className={classes.snsImg}
              alt="INSTAGRAM"
            />
          </Link>
        </div>
      </div>
    </Slide>
  );
};

export default SnsBanner;
